import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatRadioChange } from '@angular/material/radio';

import { ToastrService } from 'ngx-toastr';
import { CONST_AWS_API, API } from 'src/app/core/constants';
import { AppService } from 'src/app/core/services/app.service';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  showReportInfo: boolean = false;
  reportOptions = [];
  selectedReportCategory: any = null;
  selectedReportCategoryId: number = null;
  selectedReportSubCategory: any = null;
  //selectedReportSubCategoryId:any = null;
  questionsList: any = [];
  helpHoverId: number = null;
  reportValid: boolean = false
  userInfo: any = {};
  userInfoSubscription: Subscription;
  reportReason: string = '';
  reportFileData: any = null;
  reportFileType: string = '';
  reportFileId: any = null;
  reportFileTime: any = 0;
  settingsData: any;
  reportOptionsLength: any = 1; // Keeping 1 to avoid no data before loading the data
  @ViewChild('scrollElement') scrollElement!: ElementRef;
  slugInfo: any;
  streamInfo: any;

  constructor(
    private appService: AppService,
    private toastrService: ToastrService,
    private commonSubscribeService: CommanSubscribeService,
    private router: Router,
    private dialogRef: MatDialogRef<ReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.settingsData = data;
    this.appService.reportData.subscribe(
      (value) => {
        this.filterReportFileDetails(value)
      }
    )
  }

  ngOnInit() {
    console.log("settings data",this.commonSubscribeService?.streamInfo)
    if (this.settingsData?.bg_primary_color) {
      const button = document.querySelector('.app-report') as HTMLElement;
      if (button) {
        button.style.setProperty(
          'background-color',
          this.settingsData.bg_primary_color,
          'important'
        );
        button.style.setProperty(
          'color',
          this.settingsData.font_primary_color,
          'important'
        );
      }
    }
    this.slugInfo = this.commonSubscribeService.slugInfo;
    console.log("slug info in report component:", this.slugInfo);
    this.addStyle()
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.getReportData();
    this.selectedReportCategory = null;
    this.selectedReportCategoryId = null;
    this.selectedReportSubCategory = null;
    this.filterReportFileDetails(this.reportFileData);
  }

  addStyle() {
    const dynamicColor = this.settingsData?.font_tertiary_color;
    document.documentElement.style.setProperty('--invalid-border-color', dynamicColor);
    document.documentElement.style.setProperty('--before-border-color', dynamicColor);

    const scrollColor = this.settingsData?.form_font_secondary_color;
    const scrollBackcolor = this.settingsData?.form_bg_color;
    if (this.scrollElement && (scrollColor || scrollBackcolor)) {
      this.scrollElement.nativeElement.style.setProperty('--scroll-color', scrollColor);
      this.scrollElement.nativeElement.style.setProperty('--scroll-backcolor', scrollBackcolor);
    }

    const bgColor = this.settingsData?.bg_tertiary_color;
    document.documentElement.style.setProperty('--select-panel-bg', bgColor);

    const textColor = this.settingsData?.font_tertiary_color;
    document.documentElement.style.setProperty('--select-panel-text', textColor);
  }

  filterReportFileDetails(file) {
    if (file && file.data && file.type) {
      this.reportFileData = file['data'];
      this.reportFileType = file['type'];
      this.reportFileId = this.reportFileType == 'playerVideo' ? file['data']['id'] : file['data']['streamid'];
      this.reportFileTime = file['time'];
    }
  }

  getReportData() {
    this.appService.getRequest(API.GET_REPORT_OPTIONS).subscribe(
      (response) => {
        if (response.status == 0) {
          if (response.result.length > 0) {
            console.log('response in get', response.result)
            this.filterReportData(response.result);
          }
          this.reportOptionsLength = response.result.length;
        }
      },
      (error) => {
        console.log(error);
      }
    )
  }

  filterReportData(data) {
    this.reportOptions = []
    data.forEach(element => {
      let reportElement: any = {};
      reportElement['active_status'] = element.active_status;
      reportElement['category'] = element.category;
      reportElement['help'] = element.help;
      reportElement['id'] = element.id;
      reportElement['parent_category'] = element.parent_category;
      reportElement['sub_categories'] = element.sub_categories;
      this.reportOptions.push(reportElement);
    });
  }

  onSelectCategory() {
    this.reportValid = false;
    console.log("selected category", this.selectedReportCategory);

    if (this.selectedReportCategory) {
      if (this.selectedReportCategory.sub_categories.length == 0) {
        this.reportValid = true;
      }
      else {
        this.reportValid = false;
      }
    }
  }

  onRadioChange(event: MatRadioChange) {
    this.selectedReportCategoryId = Number(event.value['id']);
    this.questionsList = event.value.options;
    this.selectedReportSubCategory = null;
  }

  onSelectSubCategory() {
    if (this.selectedReportSubCategory) {
      this.reportValid = true;
    }
  }

  onSubmit() {
    if (this.reportReason !== null && this.reportValid) {
      const URL = API.SAVE_REPORT_ABUSE;
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Album ${albumId} reported - ${userId}`)
      const u_payload = {
        actionType: "network",
        metaData: {
          title: `Album ${albumId} reported`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.slugInfo?.organization_id || null,

        clickAction: `album-report`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
      const PAYLOAD = {
        category_id: this.selectedReportSubCategory || this.selectedReportCategoryId,
        video_id: this.reportFileId,
        additional_info: this.reportReason || '',
        report_video_time: this.reportFileTime || 0,
        url: window.location.origin + this.router.url
      };

      this.appService.postRequest(URL, PAYLOAD).subscribe(
        (response) => {
          if (response.status === 0) {
            this.toastrService.success("Submitted successfully");
            this.closeForm();
            this.closePopup(false);
          }
        }
      );
    }
  }


  closeForm() {
    this.selectedReportCategory = null;
    this.selectedReportCategoryId = null;
    this.selectedReportSubCategory = null;
    this.reportReason = '';
    this.reportValid = false
  }

  closePopup(doCallApi?: boolean) {
    if (doCallApi !== false) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`Album ${albumId} report closed - ${userId}`)
      const u_payload = {
        actionType: "album",
        metaData: {
          title: `Album ${albumId} report closed`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.slugInfo?.organization_id || null,

        clickAction: `album-report`
      }
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
    }

    this.dialogRef.close(true);
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    //this.appService.reportData.unsubscribe();
  }

  isSettingsAvailable(): boolean {
    return !!(this.settingsData?.bg_primary_color ||
      this.settingsData?.font_primary_color ||
      this.settingsData?.font_family);
  }

  getSelectStyle(): any {
    if (this.isSettingsAvailable()) {
      return {
        'background-color': this.settingsData.bg_primary_color,
        'color': this.settingsData.font_primary_color,
        'font-family': this.settingsData.font_family
      };
    }
    return {}; // Default to no custom style
  }

}
